<template>
  <div class="rcc-table-list">
    <div class="rcc-table-list__button-wrapper" v-if="editAccess">
      <rcc-button @click="$router.push({ name: 'pc-stores-new' })">
        Добавить склад
      </rcc-button>
    </div>

    <div class="rcc-table-list__table-wrapper">
      <rcc-table
        :page.sync="page"
        :pageCount="1"
        :itemsPerPage="50"
        :headers="headers"
        :rows="rows"
        :is-fixed-header="true"
        :isShowFilters="false"
        :isLoading="isDataLoading"
        @filters-changed="handleFiltersChanged"
      />
    </div>
  </div>
</template>

<script>
import Page from '@/mixins/page'
import TableList from '@/mixins/table-list'
import headerData from './header'

import RccButton from 'Components/controls/rcc-button'
import RccTable from 'Components/table/rcc-table'

export default {
  mixins: [Page, TableList],

  components: {
    RccTable,
    RccButton
  },

  computed: {
    headerData() {
      return headerData
    }
  },

  methods: {
    loadData(filters) {
      this.isDataLoading = true
      window.isLoading(true)

      this.$apiMethods.stores.list({ page: this.page, is_external: true, ...filters  })
        .then(({ pages, items }) => {
          if (!pages) {
            this.resetTableData()
            return
          }

          this.pagesCount = pages

          this.rows = items.map(item => {
            return { ...item, coordinates: `${item.lon}, ${item.lat}` }
          })
        })
        .finally(() => {
          this.isDataLoading = false
          window.isLoading(false)
        })
    }
  }
}
</script>
